/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63d7759306dd75de9f8738c35cafb7b3>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UNSAFE_baseNew = _interopRequireDefault(require("@atlaskit/icon/UNSAFE_base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const StarUnstarredIcon = props => /*#__PURE__*/_react.default.createElement(_UNSAFE_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.619a.75.75 0 0 0 1.148-.813zm-4.8-3.618-4.374 3 .848 1.237 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.237 4.375 3z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var _default = exports.default = StarUnstarredIcon;